import { Injectable } from '@angular/core';

import { BotmakerData } from '../models/user.model';

@Injectable({
	providedIn: 'root',
})
export class BotmakerService {
	initialized: boolean = false;
	shouldFetch: boolean = true;

	initialize(bmData: BotmakerData): void {
		if (!this.initialized) {
			this.initialized = true;

			window.BOTMAKER_VAR = bmData;
			const js = document.createElement('script');
			js.type = 'text/javascript';
			js.async = true;
			js.setAttribute('nonce', '{{ nonce }}');
			js.integrity =
				'sha384-VLNGCPGvAz0of4gLe8xr/3cuAu1vY1mPXxpjieLMml5o+K3wseynN+ujahN5bg1u';
			js.crossOrigin = 'anonymous';
			js.src = 'https://go.botmaker.com/rest/webchat/p/58I58P1WGD/init.js';
			document.body.appendChild(js);
		}
	}

	stop(): void {
		if (this.initialized) {
			const scripts = document.getElementsByTagName('script');
			const div = document.getElementsByTagName('div');

			for (let i = div.length; i >= 0; i--) {
				if (
					div[i]?.children.length &&
					div[i].children[0].getAttribute('name') == 'Botmaker'
				) {
					div[i].parentNode?.removeChild(div[i]);
					break;
				}
			}

			for (let i = scripts.length; i >= 0; i--) {
				if (
					scripts[i]?.getAttribute('src') != null &&
					scripts[i]?.getAttribute('defer') == null
				) {
					scripts[i].parentNode?.removeChild(scripts[i]);
				}
			}
			this.initialized = false;
		}
	}
}
